import Web3Data from './components/Web3Data.js';
import React, {useState, useEffect} from 'react';
import './App.css';
import { useWeb3 } from '@openzeppelin/network/react';

import { useGamerData } from './hooks/useGamerData';

import GamerData from './components/GamerData.js';

import { Web3ReactProvider } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'
import { useWeb3React } from '@web3-react/core'
import { InjectedConnector } from '@web3-react/injected-connector'

import {formatEther} from "@ethersproject/units";

import { Contract } from '@ethersproject/contracts'
import { isAddress } from '@ethersproject/address'

import useSWR from 'swr'

import GFCABI from './abi/GameForCrypto.abi.json'

import { CreditBalance } from './components/CreditBalance.js';
import { AddCredits } from './components/AddCredits.js';
import { Balance } from './components/Balance.js';
import { CreateContest } from './components/CreateContest.js';
import { ViewContests } from './components/ViewContests.js';

import { fetcher } from './util/Fetcher.js';

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import { ThemeProvider } from '@material-ui/core/styles';

import CssBaseline from '@material-ui/core/CssBaseline'
import theme from './theme'

import Intro from './Intro';

export const injectedConnector = new InjectedConnector({
  supportedChainIds: [
    1, // Mainet
    3, // Ropsten
    4, // Rinkeby
    5, // Goerli
    42, // Kovan
  ],
})

export const Wallet = () => {
  const { chainId, account, activate, active } = useWeb3React();

  //const [currentAccount, setCurrentAccount] = useState(null);

  const onClick = () => {
    activate(injectedConnector)
  }

  return (
    <div>
      <div>Ethereum ChainId: {chainId}</div>
      
      {active ? (
        <React.Fragment>
        <div>Account: {account}</div>
        <Balance />
        
        </React.Fragment>
      ) : (
        <Button onClick={onClick}>
          Connect Wallet
        </Button>
      )}
      
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

const infuraProjectId = '103804dbf72c4b539c09ec56d55341bc';
function App() {

  const [ethAddress, setEthAddress] = useState(null);
  const [selectedGame, setSelectedGame] = useState('Snake');

  const web3Context = useWeb3(`wss://mainnet.infura.io/ws/v3/${infuraProjectId}`);

  const { account, library } = useWeb3React();

  const classes = useStyles();

  useEffect(() => {
    
    if(account && account !== ethAddress){
    console.log(`Account From App**`, account);
    
      setEthAddress(account);
    }


  },[account])

  const handleSetAddress = (address) => {

    console.log(`Setting Address..`);

    if(address !== ethAddress){
      setEthAddress(address);
    }

  }

  const handleSelectGame = (game) => {

    console.log(`handleSelectGame..`);

    if(game !== selectedGame){
      setSelectedGame(game);
    }

  }

  return (
  <ThemeProvider theme={theme}>
  <CssBaseline />
  <AppBar position="static">
        <Toolbar>
          <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <MenuIcon />
          </IconButton>
          <Typography variant="h5" className={classes.title}>
           Game For Crypto 
          </Typography>
          <Typography variant="p" className={classes.title}>
          Video Gaming Contest Platform Utilizing Crypto
          </Typography>
          <Wallet setAddress={handleSetAddress}/>
        </Toolbar>
  </AppBar>
  <div className="App">
    <div>
        
      
      
    {ethAddress && 
    <React.Fragment>

      <GamerData address={ethAddress} />
      <Grid container spacing={3} style={{padding: 8}}>

        <Grid item xs style={{margin: 8, padding: 8}}>
        <AddCredits address={ethAddress} />
        </Grid>

        <Grid item xs style={{margin: 8, padding: 8}}>
        <CreditBalance />
        </Grid>

      </Grid>
      
      
      <CreateContest gameValue={selectedGame} selectedGame={handleSelectGame}/>
      <ViewContests />
      
    </React.Fragment>
    }

    <Intro />

    </div>
  </div>
  </ThemeProvider>
  );
}
export default App;